import React from 'react';
import cn from 'classnames';
import { navigationList } from './constants';

import styles from './catalogNavigation.module.scss';

interface IProps {
  navigationFilter: any[],
  onClickHandler: (item: any) => void,
}

const CatalogNavigation = ({ onClickHandler, navigationFilter }: IProps) => (
  <div className={ styles.catalogNavigationContainer }>
    <div className={ styles.catalogNavigation }>
      { navigationList.map((item) => (
        navigationFilter.indexOf(item) > -1 ? (
          <div
            className={ styles.catalogNavigationItem }
            key={ item }
            onClick={ () => onClickHandler(navigationFilter.indexOf(item)) }
          >
            { item }
          </div>
        ) : (
          <div
            className={ cn(styles.catalogNavigationItem, styles.catalogNavigationItemDisabled) }
            key={ item }
          >
            { item }
          </div>
        )
      )) }
    </div>
  </div>
);

export default CatalogNavigation;
